<template>
    <Card class="layout-card" style="height: 100%;">
        <div style="display:flex;justify-content: space-between;margin-bottom: 10px;flex-shrink: 0;">
            <div class="search-form">
                <Select style="width: 100px" v-model="searchForm.system" placeholder="系统" clearable>
                    <Option :value="0">IOS</Option>
                    <Option :value="1">Android</Option>
                </Select>
                <DatePicker :editable="false" :value="listDate" style="flex-shrink: 0;width: 280px" placeholder="请选择时间" type="datetimerange"  @on-change="getListDate"></DatePicker>
                <Select style="width: 100px" v-model="searchForm.force" placeholder="是否提醒更新" clearable>
                    <Option :value="0">否</Option>
                    <Option :value="1">是</Option>
                </Select>
                <Button type="primary" @click="getData()">查询</Button>
                <Button @click="handleReset()">重置</Button>
            </div>
            <div><Button type="primary" @click="handleOpenEditModal()">添加</Button></div>
        </div>
        <div style="height: 100%;overflow:auto">
        <Table :data="tableData" :columns="columns">
            <template #action="{row}">
                <div>
                    <a style="margin-left: 10px;" @click="handleOpenEditModal(row)">编辑</a>
                    <Poptip confirm title="确定要删除吗？" transfer @on-ok="handleDel(row)"><a style="margin-left: 10px;color: red">删除</a></Poptip>

                </div>
            </template>
            <Pages slot="footer" :page="page" :func="getData"></Pages>
        </Table>
        </div>

        <Modal v-model="editVisible" :title="(form.id?'编辑':'新增')+'版本'">
            <Form @submit.native.prevent :label-width="130" :model="form" ref="formRef" v-if="editVisible">
                <FormItem label="版本号：" prop="appVersion" :rules="[{required:true,message:'请输入版本号'}]">
                    <Input :maxlength="50" v-model="form.appVersion" />
                </FormItem>
                <FormItem label="选择系统：" prop="sys" :rules="[{required:true,message:'请选择系统'}]">
                    <Select v-model="form.sys">
                        <Option :value="0">IOS</Option>
                        <Option :value="1">Android</Option>
                    </Select>
                </FormItem>
                <FormItem label="是否提醒更新：" prop="forceUpdate" :rules="[{required:true,message:'请选择'}]">
                    <i-switch v-model="form.forceUpdate"></i-switch>
                </FormItem>
                <FormItem label="谷歌更新提醒：" prop="googleUpdateType" v-if="form.sys === 1">
                    <Select v-model="form.googleUpdateType" clearable>
                        <Option :value="0">灵活更新</Option>
                        <Option :value="1">立即更新</Option>
                    </Select>
                </FormItem>
                <FormItem label="上线时间：" prop="onlineTime" :rules="[{required:true,message:'请选择上线时间'}]">
                    <DatePicker :editable="false" format="yyyy-MM-dd HH:mm:ss" type="datetime" v-model="form.onlineTime" @on-change="$set(form, 'onlineTime', $event)" />
                </FormItem>
                <FormItem label="更新内容：" prop="renewalContents" :rules="[{required:true,message:'请输入更新内容'}]">
                    <Input type="textarea" placeholder="仅后台记录，不会向用户展示" v-model="form.renewalContents" :maxlength="400" show-word-limit :autosize="{
                        minRows: 2,
                        maxRows: 7
                    }" />
                </FormItem>
            </Form>
            <template #footer>
                <Button @click="editVisible=false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
            </template>
        </Modal>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getVersionList, addVersion, delVersion, editVersion, getVersionInfo } from '@/api/version'
export default {
  components: {
    Pages
  },
  data() {
    return {
      editVisible:false,
      form:{
        onlineTime: ''
      },
      searchForm:{},
      submitLoading:false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      listDate: [],
      tableData: [],
      columns: [
        // {
        //   title: 'id',
        //   key: 'id'
        // },
        {
          title: '版本号',
          key: 'appVersion'
        },
        {
          title: '系统',
          key: 'sys',
          render: (h,params)=>{
            return <div>
                {['IOS','Android'][params.row.sys]}
              </div>
          }
        },
        {
          title: '上线时间',
          key: 'onlineTime'
        },
        {
          title: '更新内容',
          key: 'renewalContents',
          width: 400
        },
        {
          title: '是否提醒更新',
          key: 'forceUpdate',
          render: (h,params)=>{
            return <div>
                {params.row.forceUpdate?'是':'否'}
              </div>
          }
        },
        {
          title: '创建人',
          key: 'createUserName'
        },
        {
          title: '最后修改时间',
          key: 'updateTime'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action'
        }
      ]
    }
  },
  computed:{
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('system/version')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods:{
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getVersionList({
        ...this.page,
        ...this.searchForm,
        force: this.searchForm.force==null?'':this.searchForm.force
      }).then(({ data }) => {

        this.tableData = data.records
        this.page.current = data.current
        this.page.total = data.total
      })
    },
    getListDate(data) {
      console.log(data);
      
      this.listDate = data
      this.searchForm.startDate = data[0]
      this.searchForm.endDate = data[1]
    },
    async handleOpenEditModal(row) {
      if (row) {
        const r = await getVersionInfo(row.id)
        this.form = r.data
      } else {
        this.form = {
          forceUpdate: false,
          onlineTime: ''
        }
      }
      this.editVisible = true
    },
    handleSubmit() {
      this.$refs.formRef.validate(r => {
        if (r) {
          const func = this.form.id ? editVersion : addVersion
          this.submitLoading = true
          func({
            ...this.form
          }).then(r => {
            this.$Message.success('操作成功')
            this.getData()
            this.submitLoading = false
            this.editVisible = false
          }).catch(() => {
            this.submitLoading = false
          })
        }
      })
    },
    handleDel(row) {
      delVersion(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
      this.listDate = []
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="less">
.search-form{
    display:flex;
    &>*{
        margin: 0 5px;
    }
}
.layout-card{
  /deep/ .ivu-card-body{
    height: 100%;display:flex;flex-direction: column;
  }
}
</style>